import { updateObject } from 'utils/updateObject'

const initialState = { hierarchy: [], cantGetHierarchy: false }

const setValues = (state, { payload }) => updateObject(state, { ...payload })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'STATISTICS/PROFILES_HIERARCHY_SET':
      return setValues(state, action)
    default:
      return state
  }
}

export default reducer
